// extracted by mini-css-extract-plugin
export default {"wrapper":"nid-input_wrapper__AGL2w","focused":"nid-input_focused__arv0F"};